export const LOCAL_STORAGE_AUTH_TOKEN = "sonnen_partner_auth";
export const LOCAL_STORAGE_REFRESH_TOKEN = "sonnen_partner_refresh";
export const LOCAL_STORAGE_POPUP_ID = "sonnen_partner_popup";
export const LOCAL_STORAGE_LANGUAGE_CODE = "sonnen_partner_country_code";
